import { render, staticRenderFns } from "./QcOrderList.vue?vue&type=template&id=2e27b9d8&scoped=true&"
import script from "./QcOrderList.ts?vue&type=script&lang=js&"
export * from "./QcOrderList.ts?vue&type=script&lang=js&"
import style0 from "./QcOrderList.vue?vue&type=style&index=0&id=2e27b9d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e27b9d8",
  null
  
)

export default component.exports